/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InternalUserUserEventResponseV3TypeEnum = {
    UserEvent: 'user_event'
};
/**
 * Check if a given object implements the InternalUserUserEventResponseV3 interface.
 */
export function instanceOfInternalUserUserEventResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('timezone' in value) || value['timezone'] === undefined)
        return false;
    return true;
}
export function InternalUserUserEventResponseV3FromJSON(json) {
    return InternalUserUserEventResponseV3FromJSONTyped(json, false);
}
export function InternalUserUserEventResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'location': json['location'] == null ? undefined : json['location'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'startDate': (new Date(json['start_date'])),
        'endDate': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'webinarUrl': json['webinar_url'] == null ? undefined : json['webinar_url'],
        'timezone': json['timezone'],
    };
}
export function InternalUserUserEventResponseV3ToJSON(json) {
    return InternalUserUserEventResponseV3ToJSONTyped(json, false);
}
export function InternalUserUserEventResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'title': value['title'],
        'description': value['description'],
        'location': value['location'],
        'logo': value['logo'],
        'start_date': ((value['startDate']).toISOString()),
        'end_date': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'webinar_url': value['webinarUrl'],
        'timezone': value['timezone'],
    };
}
